var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCustomLogo)?_c('img',_vm._g({staticClass:"gl-brand-logo",class:`gl-brand-logo--${_vm.variant}`,attrs:{"alt":_vm.brandName,"src":_vm.customUrl},on:{"error":_vm.onCustomLogoError}},_vm.$listeners)):_c(_vm.fallbackComponent,_vm._g({tag:"component"},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }